import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useState } from 'react';
export function useSessionStorage(key, initialValue) {
  var _useState = useState(function () {
      if (typeof window === 'undefined') {
        return initialValue;
      }
      try {
        var item = window.sessionStorage.getItem(key);
        return item ? JSON.parse(item) : initialValue;
      } catch (error) {
        // eslint-disable-next-line no-console -- We want to see the error
        console.log(error);
        return initialValue;
      }
    }),
    _useState2 = _slicedToArray(_useState, 2),
    storedValue = _useState2[0],
    setStoredValue = _useState2[1];
  var setValue = function setValue(valueOrFunction) {
    try {
      setStoredValue(function (prevValue) {
        var valueToStore = typeof valueOrFunction === 'function' ? valueOrFunction(prevValue) : valueOrFunction;
        if (typeof window !== 'undefined') {
          window.sessionStorage.setItem(key, JSON.stringify(valueToStore));
        }
        return valueToStore;
      });
    } catch (error) {
      // eslint-disable-next-line no-console -- We want to see the error
      console.log(error);
    }
  };
  return [storedValue, setValue];
}